const types = Object.freeze({
  SimpleChoiceHorizontal: 1,
  Text: 2,
  SimpleChoiceHorizontalWithDependency: 11,
});
export default types;
